"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ALLERGY_MAX_ITEMS () {
        return _patientcreate.ALLERGY_MAX_ITEMS;
    },
    get ALLERGY_MAX_LENGTH () {
        return _patientcreate.ALLERGY_MAX_LENGTH;
    },
    get AllergyStatusSchema () {
        return _allergystatus.AllergyStatusSchema;
    },
    get CIVIL_STATUS_LABELS () {
        return _patientcreate.CIVIL_STATUS_LABELS;
    },
    get CivilStatusSchema () {
        return _patientcreate.CivilStatusSchema;
    },
    get EmergencyContactSchema () {
        return _patientcreate.EmergencyContactSchema;
    },
    get NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE () {
        return _patientcreate.NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE;
    },
    get PATIENT_ALERT_LABELS () {
        return _patientalert.PATIENT_ALERT_LABELS;
    },
    get PATIENT_ALLERGIES_CONFLICT () {
        return _allergystatus.PATIENT_ALLERGIES_CONFLICT;
    },
    get PATIENT_EXPORT_NOT_INCLUDED_V1 () {
        return _patientexport.PATIENT_EXPORT_NOT_INCLUDED_V1;
    },
    get PATIENT_EXPORT_SCHEMA_VERSION () {
        return _patientexport.PATIENT_EXPORT_SCHEMA_VERSION;
    },
    get PATIENT_EXPORT_SECTIONS_V1 () {
        return _patientexport.PATIENT_EXPORT_SECTIONS_V1;
    },
    get PATIENT_STALE () {
        return _patientupdate.PATIENT_STALE;
    },
    get PATIENT_UPDATE_GROUPS () {
        return _patientupdate.PATIENT_UPDATE_GROUPS;
    },
    get PHILHEALTH_PIN_LOCKED () {
        return _patientupdate.PHILHEALTH_PIN_LOCKED;
    },
    get PatientAlertSchema () {
        return _patientalert.PatientAlertSchema;
    },
    get PatientAllergiesSchema () {
        return _patientcreate.PatientAllergiesSchema;
    },
    get PatientAllergiesUpdateRequestSchema () {
        return _patientallergiesupdate.PatientAllergiesUpdateRequestSchema;
    },
    get PatientAllergiesUpdateResponseSchema () {
        return _patientallergiesupdate.PatientAllergiesUpdateResponseSchema;
    },
    get PatientContactGroupSchema () {
        return _patientupdate.PatientContactGroupSchema;
    },
    get PatientCreateRequestSchema () {
        return _patientcreate.PatientCreateRequestSchema;
    },
    get PatientCreateResponseSchema () {
        return _patientcreate.PatientCreateResponseSchema;
    },
    get PatientDetailSchema () {
        return _patientdetail.PatientDetailSchema;
    },
    get PatientExportFormatSchema () {
        return _patientexport.PatientExportFormatSchema;
    },
    get PatientExportNotIncludedSchema () {
        return _patientexport.PatientExportNotIncludedSchema;
    },
    get PatientExportQuerySchema () {
        return _patientexport.PatientExportQuerySchema;
    },
    get PatientExportSectionSchema () {
        return _patientexport.PatientExportSectionSchema;
    },
    get PatientGovernmentIdsGroupSchema () {
        return _patientupdate.PatientGovernmentIdsGroupSchema;
    },
    get PatientIdentityGroupSchema () {
        return _patientupdate.PatientIdentityGroupSchema;
    },
    get PatientListFilterSchema () {
        return _patientlist.PatientListFilterSchema;
    },
    get PatientListItemSchema () {
        return _patientlist.PatientListItemSchema;
    },
    get PatientRecordExportSchema () {
        return _patientexport.PatientRecordExportSchema;
    },
    get PatientSearchRequestSchema () {
        return _patientlist.PatientSearchRequestSchema;
    },
    get PatientSearchResponseSchema () {
        return _patientlist.PatientSearchResponseSchema;
    },
    get PatientUpdateRequestSchema () {
        return _patientupdate.PatientUpdateRequestSchema;
    },
    get PatientUpdateResponseSchema () {
        return _patientupdate.PatientUpdateResponseSchema;
    },
    get PhilHealthPinSchema () {
        return _patientlist.PhilHealthPinSchema;
    },
    get maskPhilsysNumber () {
        return _identifiers.maskPhilsysNumber;
    },
    get normalizePhMobile () {
        return _identifiers.normalizePhMobile;
    },
    get normalizePhilsysNumber () {
        return _identifiers.normalizePhilsysNumber;
    },
    get patientExportFilename () {
        return _patientexport.patientExportFilename;
    },
    get toCanonicalPhilhealthPin () {
        return _identifiers.toCanonicalPhilhealthPin;
    }
});
const _patientalert = require("./patient-alert");
const _patientlist = require("./patient-list");
const _identifiers = require("./identifiers");
const _patientcreate = require("./patient-create");
const _allergystatus = require("./allergy-status");
const _patientallergiesupdate = require("./patient-allergies-update");
const _patientupdate = require("./patient-update");
const _patientdetail = require("./patient-detail");
const _patientexport = require("./patient-export");
